import React from "react";
import PostList from "../../components/clients/PostList";
import FormPost from "../../components/clients/FormPost";

const TodoApp = () => {
  return (
    <>
      <FormPost />
      <PostList />
    </>
  );
};

export default TodoApp;
